import { getEnvironment, ENVIRONMENT } from './env'

export const BACKEND_URLS = {
  LOCAL: 'https://api.2donglotto.co',
  // LOCAL: 'https://3monkeys-dev.api.vava.dev',
  DEVELOPMENT: 'https://api.2donglotto.co',
  STAGING: 'https://api.2donglotto.co',
  TEST: 'https://api.2donglotto.co',
  PRODUCTION: 'https://api.2donglotto.co',
}

export const FRONTEND_URLS = {
  LOCAL: 'http://localhost:3001/',
  DEVELOPMENT: 'https://www.2donglotto.co',
  STAGING: 'https://www.2donglotto.co',
  PRODUCTION: 'https://www.2donglotto.co',
}

export const getBackendUrl = () => {
  const env = getEnvironment()

  if (env === ENVIRONMENT.LOCAL) {
    return BACKEND_URLS.LOCAL
  }

  if (env === ENVIRONMENT.DEVELOPMENT) {
    return BACKEND_URLS.DEVELOPMENT
  }

  if (env === ENVIRONMENT.STAGING) {
    return BACKEND_URLS.STAGING
  }

  if (env === ENVIRONMENT.TEST) {
    return BACKEND_URLS.TEST
  }

  if (env === ENVIRONMENT.PRODUCTION) {
    return BACKEND_URLS.PRODUCTION
  }

  return BACKEND_URLS.DEVELOPMENT
}

export const getFrontendUrl = () => {
  const env = getEnvironment()

  if (env === ENVIRONMENT.DEVELOPMENT) {
    return FRONTEND_URLS.DEVELOPMENT
  }

  if (env === ENVIRONMENT.PRODUCTION) {
    return FRONTEND_URLS.PRODUCTION
  }

  return FRONTEND_URLS.DEVELOPMENT
}
